import dayjs from 'dayjs';
import { ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { twMerge } from 'tailwind-merge';

export interface HomeRotationTimeLeftProps {
    date: Date;
    isActive?: boolean;
}

const Box = ({ className, children }: { className?: string; children?: ReactNode }) => {
    return (
        <div className={twMerge('flex h-28 w-36 items-center justify-center text-white', className)}>{children}</div>
    );
};

export default function HomeRotationTimeLeft({ date, isActive }: HomeRotationTimeLeftProps) {
    const getTimeLeft = useCallback(() => {
        const dt = dayjs(date);
        const now = dayjs();

        return {
            days: dt.diff(now, 'days'),
            hours: dt.diff(now, 'hours') % 24,
            minutes: dt.diff(now, 'minutes') % 60,
        };
    }, [date]);

    const [timeLeft, setTimeLeft] = useState(() => getTimeLeft());

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getTimeLeft());
        }, 1000);

        return () => clearInterval(interval);
    }, [getTimeLeft]);

    return (
        <div className="flex items-center gap-x-8">
            <div className="flex flex-col items-center">
                <Box className={twMerge('rounded-t-lg', !isActive ? 'bg-[#127AFE]' : 'bg-red-600')}>
                    <span className="font-semibold">{timeLeft.days}</span>
                </Box>
                <Box className="h-auto w-36 rounded-b-lg bg-gray-600 p-4">
                    <span className="text-[10px] font-bold uppercase text-white">Days</span>
                </Box>
            </div>
            <div className="flex flex-col items-center">
                <Box className={twMerge('rounded-t-lg', !isActive ? 'bg-[#127AFE]' : 'bg-red-600')}>
                    <span className="font-semibold">{timeLeft.hours}</span>
                </Box>
                <Box className="h-auto w-36 rounded-b-lg bg-gray-600 p-4">
                    <span className="text-[10px] font-bold uppercase text-white">Hrs</span>
                </Box>
            </div>
            <div className="flex flex-col items-center">
                <Box className={twMerge('rounded-t-lg', !isActive ? 'bg-[#127AFE]' : 'bg-red-600')}>
                    <span className="font-semibold">{timeLeft.minutes}</span>
                </Box>
                <Box className="h-auto w-36 rounded-b-lg bg-gray-600 p-4">
                    <span className="text-[10px] font-bold uppercase text-white">Min</span>
                </Box>
            </div>
        </div>
    );
}
